import { createTRPCReact, httpBatchLink } from "@trpc/react-query";
import { QueryClient } from "@tanstack/react-query";
import type { AppRouter } from "../../../api/src/trpc/router";
import { getAuthToken } from "./auth";

export const trpc = createTRPCReact<AppRouter>();

/**
 * Get the API base URL based on environment
 */
function getBaseUrl(): string {
  // In development, use local API
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return "http://localhost:8787";
  }

  // In production, use the workers API
  return "https://baby-cafe-guide-api.yamaguchi-c92.workers.dev";
}

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: `${getBaseUrl()}/trpc`,
      headers() {
        const token = getAuthToken();
        return token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {};
      },
    }),
  ],
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});
